export const restrictToAlphabets = (e) => {
    // Allow: backspace, delete, tab, escape, enter, arrows, home, end
    const allowedKeys = [8, 9, 13, 27, 37, 38, 39, 40, 46, 36, 35, 32]; // 32 is space

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].includes(e.keyCode)) {
        return;
    }

    // If allowed key or character is a letter
    if (
        allowedKeys.includes(e.keyCode) ||
        (e.keyCode >= 65 && e.keyCode <= 90) || // A-Z
        (e.keyCode >= 97 && e.keyCode <= 122) || // a-z
        e.keyCode === 32 // space
    ) {
        return;
    }

    // Prevent the input
    e.preventDefault();
};